import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import React from "react";
import SaveIcon from "@mui/icons-material/Save";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CancelIcon from "@mui/icons-material/Cancel";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import frLocale from "date-fns/locale/fr";

const DialogEditEnterprise = ({
  editEmpresa,
  open,
  handleOpenConfig,
  handleChangeDataBloqueio,
  handleSave,
  handleClose,
  verificaPendencias,
  handleChange,
  handleAtivar,
  handleLiberarEmpresa,
}) => {
  return (
    <Dialog open={open} onClose={handleOpenConfig}>
      <DialogTitle> Editar Empresa</DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="center"
          width="100%"
        >
          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
          >
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={frLocale}
            >
              <DatePicker
                label="Data de bloqueio"
                format="dd/MM/yyyy"
                value={
                  editEmpresa?.dataBloqueio
                    ? new Date(editEmpresa.dataBloqueio)
                    : null
                }
                onChange={(newValue) => handleChangeDataBloqueio(newValue)}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    required: true,
                    variant: "outlined",
                  },
                }}
                clearable
              />
            </LocalizationProvider>
          </Grid>

          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
          >
            <Button
              variant="contained"
              onClick={verificaPendencias}
              color="primary"
              fullWidth
              style={{ marginRight: "10px", height: "3.5rem" }}
              startIcon={<MonetizationOnIcon />}
            >
              Verificar pendências
            </Button>
          </Grid>

          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
          >
            <TextField
              name="idExterno"
              variant="outlined"
              fullWidth
              label="IdExterno"
              value={editEmpresa ? editEmpresa.idExterno : ""}
              onChange={(event) => handleChange(event)}
            />
          </Grid>

          <Grid
            size={{
              xs: 6,
              sm: 6,
            }}
          >
            <FormControl component="fieldset">
              <FormControlLabel
                control={
                  <Switch
                    defaultChecked={editEmpresa ? editEmpresa.ativo : null}
                    name="ativarEmpresa"
                    color="secondary"
                    onChange={(event) => handleAtivar(event, editEmpresa)}
                  />
                }
                label={
                  editEmpresa
                    ? editEmpresa.ativo
                      ? "Empresa ativa"
                      : "Empresa inativa"
                    : null
                }
              />
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        {editEmpresa ? (
          editEmpresa.tipoConta === "TEMPORARIA" ||
          editEmpresa.tipoConta === "TEMPORARIA_EXTENDED" ? (
            <React.Fragment>
              <Typography style={{ color: "red" }}>Periodo de Teste</Typography>
              <Button
                variant="outlined"
                onClick={() => {
                  handleLiberarEmpresa();
                }}
              >
                Liberar Empresa
              </Button>
            </React.Fragment>
          ) : null
        ) : null}

        <Button
          color="primary"
          variant="text"
          onClick={handleClose}
          startIcon={<CancelIcon />}
        >
          Cancelar
        </Button>

        <Button
          aria-expanded={true}
          variant="contained"
          color="secondary"
          onClick={handleSave}
          startIcon={<SaveIcon />}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogEditEnterprise;
